<template>
  <validation-observer ref="dataForm">
    <b-row>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.academicLevel')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="academicLevel"
            vid="academicLevel"
            rules="required"
            :custom-messages="{ required: ' المستوى تعليمي مطلوب' }"
          >
            <!-- <b-form-select
             
              :options="educationLevel"
              text-field="Level"
              value-field="Code_"
            >
            </b-form-select> -->
            <b-form-select
              v-model="newItem.AcademicLevel"
              :placeholder="$t('addwizard.academicLevel')"
            >
              <option value="CER">درجة البكالوريوس</option>
              <option value="DIP">شهادة</option>
              <option value="BAC">دبلوم</option>
              <option value="PHD">الدكتوراه</option>
              <option value="MAS">درجة الماجستير</option>
              <option value="OTH">أخرى</option>
            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.Certificate_Name')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Certificate_Name"
            vid="Certificate_Name"
            rules="required"
            :custom-messages="{ required: ' اسم الشهادة مطلوب' }"

          >
            <b-form-input
              id="input-13"
              v-model="newItem.certificate_Name"
              type="text"
              :placeholder="$t('addwizard.Certificate_Name')"
            >
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.institution_Name')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="institution_Name"
            vid="institution_Name"
            rules="required"
            :custom-messages="{ required: '  اسم الجهة الدراسية مطلوب' }"

          >
            <b-form-input
              id="input-13"
              v-model="newItem.institution_Name"
              type="text"
              :placeholder="$t('addwizard.institution_Name')"
            >
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.Year_of_Graduation')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Year_of_Graduation"
            vid="Year_of_Graduation"
            :rules="{
              required,
              min_value: 1970,
              max_value: new Date().getFullYear(),
            }"
            :custom-messages="{ required: ' سنة التخرج مطلوبة',

              min_value: ' يجب أن تكون سنة التخرج أكبر من 1970',
              max_value: ' يجب أن تكون سنة التخرج أقل من السنة الحالية',
             }"

          >
            <b-form-input
              id="input-13"
              v-model="newItem.Year_of_Graduation"
              type="number"
              :placeholder="$t('addwizard.Year_of_Graduation')"
            >
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.Grade_GPA')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Grade_GPA"
            vid="Grade_GPA"
            rules="required"
            :custom-messages="{ required: ' المعدل التراكمي مطلوب' }"

          >
            <b-form-input
              id="input-13"
              v-model="newItem.Grade_GPA"
              type="number"
              :placeholder="$t('addwizard.Grade_GPA')"
            >
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.specialazation')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="specialazation"
            vid="specialazation"
            rules="required"
            :custom-messages="{ required: ' التخصص الدراسي مطلوب' }"

          >
            <b-form-input
              id="input-13"
              v-model="newItem.specialazation"
              type="text"
              :placeholder="$t('addwizard.specialazation')"
            >
            </b-form-input>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.educationCountry')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="educationCountry"
            vid="educationCountry"
            rules="required"
            :custom-messages="{ required: ' الدولة مطلوبة' }"

            
          >
            <v-select
              v-model="newItem.educationCountry"
              label="NameAr"
              :options="citizenship"
              :reduce="(country) => country.Code"
              :placeholder="$t('addwizard.educationCountry')"
              dir="rtl"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-col lg="12">
        <b-form-group
          id="input-group-CERT"
          :label="$t('addwizard.CERT')"
          label-for="input-CERT"
          label-cols-md="3"
        >
          <b-form-file
            v-model="newItem.CERT"
            accept="application/pdf,image/*"
            :placeholder="$t('addwizard.CERT')"
          />
        </b-form-group>
      </b-col> -->
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min_value, max_value } from "@validations";
import mediuEduController from "@/Controllers/MediuEduController";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    required,
    min_value,
    max_value,
  },
  data() {
    return {
      newItem: {},
      citizenship: [],
      educationLevel: [],
    };
  },
  async created() {
    const ct = new mediuEduController();
    this.educationLevel = await ct.GetEducationLevel();

    this.citizenship = await ct.GetCitizenship();
  },
  methods: {
    async returnData() {
      const isValid = await this.$refs.dataForm.validate();
      console.log(this.$refs.dataForm);
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>